import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';

const iconStyles = xcss({
	backgroundColor: 'color.background.neutral',
	height: '20px',
	borderRadius: 'border.radius.050',
	border: '1px solid transparent',
	color: 'color.text.subtle',
	font: 'font.body.small',
	display: 'flex',
	alignItems: 'center',
	paddingInline: 'space.050',
	paddingBlock: '0',
});

export const ControlIcon = () => <Box xcss={iconStyles}>Ctrl</Box>;
